import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import createInfo from "../Purchase.module.css";
import StyleInfo from "../../../BookModule.module.css";
import Select, { components } from "react-select";
import { Download, Search } from "@mui/icons-material";
import Creatable from "react-select/creatable";
import toast from "react-hot-toast";
import moment from "moment";
import ViewIcon from "../ViewIcon.png";
import { customStyles } from "../../../../../../../pages/customStyles";
// import Loader from "../../../../Loader";
import { Chip, Paper, styled } from "@mui/material";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../../../labels";
import { AxiosInstance } from "../../../../../../../axios";
import Loader from "../../../../../Loader";
export default function ViewCourierDetails() {
  const { id } = useParams();
  const location = useLocation();
  const { order_pk } = location.state;

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  let page = R_PER_PAGE;
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [applicableCategories, setApplicableCategories] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [author_name, setAuthor_name] = useState([]);
  const [publisher_name, setPublisher_name] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [courseIds, setCourseIds] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialfields, setInitialfields] = useState({
    trackingID: "",
    orderID: "",
  });
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [auData, setAuData] = useState([]);
  const [pubData, setPubData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [categoryId, setCategoryId] = useState([]);
  const [removedValues, setRemovedValues] = useState([]);
  const [visible_to_user, setVisible_to_user] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [updateListData, setUpdateListData] = useState();

  const [appBatch, setAppBatch] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);

  const [error, setError] = useState({});
  const [updateChipData, setUpdateChipData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    author: false,
    publisher: false,
    visible_to_user: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
  });
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  /**fetch the data for Category */

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenAuthorIds = new Set();
      const seenPublisherIds = new Set();
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const auDatas = data
        .filter((es) => {
          if (seenAuthorIds.has(es.author_id)) {
            return false; // Skip this entry if the author_id is already seen
          } else {
            seenAuthorIds.add(es.author_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          author_name: es.author,
          author_id: es.author_id,
        }));

      setAuData(auDatas);
      const PublishDatas = data
        .filter((es) => {
          if (seenPublisherIds.has(es.publisher_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenPublisherIds.add(es.publisher_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          publisher_name: es.publisher,
          publisher_id: es.publisher_id,
        }));

      setPubData(PublishDatas);
      const CourseDatas = data
        .filter((es) => {
          if (seenCourseIds.has(es.group_course_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      const SubjectDatas = data
        .filter((es) => {
          if (seenSubjectIds.has(es.subject_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
    }
  }

  // const handlechangeSelectDropdown = (selectedOptions, dname) => {
  //   if (dname === "emailIds") {
  //     const ids = selectedOptions?.map((option) => option.value) || [];
  //     const labels = selectedOptions?.map((option) => option.label) || [];
  //     const userIds = selectedOptions?.map((option) => option.user_id || null) || [];

  //     // Determine new emails
  //   const newEmails = selectedOptions?.filter(option => !initialfields.emailIds.includes(option.value)) || [];
  //   const modifiedNewEmails = newEmails.map(option => ({
  //     ...option,
  //     id: "", // Set id to empty string for new emails
  //   }));
  //     const prevIds = initialfields.emailIds || [];
  //     const removed = prevIds.filter((id) => !ids.includes(id));
  //     // const removed = initialfields.emailIds.filter((prevId) => !ids.includes(prevId));
  //     setRemovedValues((prev) => [...prev, ...removed]);
  //     setInitialfields((prevState) => ({
  //       ...prevState,
  //       [dname]: ids,
  //       ["emailLabel"]: labels,
  //       ["userIds"]: userIds.filter((id) => id !== null),
  //       newEmails: modifiedNewEmails,
  //     }));
  //     setError((prevState) => ({
  //       ...prevState,
  //       [dname]: "",
  //     }));
  //   }
  // };

  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  useEffect(() => {
    // if (updateChipData?.length > 0) {
    loadListdata();
    // }
  }, [updateChipData]);
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
  }
  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };
  const handleChange = (event) => {
    const { name, files, value } = event.target;
    if (name === "content_path") {
      // alert("xcvxcv");
      if (files && files.length > 0) {
        const course_content_path = files[0];
        setInitialfields({
          ...initialfields,
          content_path: null,
          content_path_original: null,
        });
        if (files[0].type === "text/html") {
          const formData = new FormData();
          formData.append("course_content_sheet", course_content_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setInitialfields({
                ...initialfields,
                content_path: res.data.path,
                content_path_original: res.data.originalname,
              });
            })
            .catch((error) => {
              return error;
            });
          setError({
            ...error,
            [name]: "",
          });
        } else {
          setError({
            ...error,
            [name]: "Only HTML files are allowed.",
          });
          setInitialfields({
            ...initialfields,
            content_path: null,
            content_path_original: null,
          });
        }
      } else {
        setInitialfields({
          ...initialfields,
          content_path: null,
          content_path_original: null,
        });
        setError({
          ...error,
          [name]: "",
        });
      }
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  // Ref
  const course_ref = useRef(null);
  const type_of_admission_ref = useRef(null);
  const category_ref = useRef(null);
  const sub_category_ref = useRef(null);
  const sub_category_refssss = useRef(null);
  const ebook_ref = useRef(null);
  const filterRef_author = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const filterRef_publisher = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_subject = useRef(null);
  const txtBSearch_sub = useRef(null);
  const filterRef_visible_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const txtBSearch_course = useRef(null); //search icon
  const filterRef_course = useRef(null);

  let filterSearch = [];

  // Validation error
  const validateFields = (data) => {
    const errors = {};
    if (!data.userName) {
      errors.orderID = "Please enter a  order id";
    }

    if (data.actualPrice === "") {
      errors.trackingID = "Please enter a tracking id";
    }

    validateFocusCommentSection(data);
    return errors;
  };
  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const [courierDetails, setCourierDetails] = useState();

  function loadListdata() {
    let statusFilter = {
      id: parseInt(id),
      order_pk: order_pk,
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/delivered_books_view", statusFilter)
      .then((res) => {
        setCourierDetails(res.data.courier_details);
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.Title) {
      course_ref.current.focus();
    } else if (!COMSECFO.CouponAmount) {
      type_of_admission_ref.current.focus();
    } else if (!COMSECFO.emailIds) {
      category_ref.current.focus();
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };
  const handleChangeBookOrder = (e, bookId) => {
    if (e.target.checked) {
      // Add book to the selectedBooks list
      setSelectedBooks((prev) => {
        const updatedBooks = [
          ...prev,
          currentData.find((book) => book.id === bookId),
        ];
        // Reassign sequential s.no
        return updatedBooks.map((book, index) => ({
          ...book,
          serialNumber: index + 1,
        }));
      });
    } else {
      // Remove book from the selectedBooks list
      setSelectedBooks((prev) => {
        const updatedBooks = prev.filter((book) => book.id !== bookId);
        // Reassign sequential s.no
        return updatedBooks.map((book, index) => ({
          ...book,
          serialNumber: index + 1,
        }));
      });
    }
  };
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "author") {
      if (checked) {
        setAuthor_name([{ id: value, name: name, type: "author" }]);
      } else {
        setAuthor_name(author_name.filter((item) => item.id !== value));
      }
    }
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "author") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        author: false,
      });
    } else if (name === "publisher") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        publisher: false,
      });
    } else if (name === "visible_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        visible_to_user: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    }
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "author") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        author: !prevState.author, // Toggle the value
        visible_to_user: false,
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
      }));
      setAuthor_name(updateChipData.filter((ui) => ui.type === "author"));
    } else if (boxName === "publisher") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: false,
        publisher: !prevState.publisher, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setPublisher_name(updateChipData.filter((ui) => ui.type === "publisher"));
    } else if (boxName === "visible_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: !prevState.visible_to_user, // Toggle the value
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setVisible_to_user(
        updateChipData.filter((ui) => ui.type === "visible_to_user")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    }
  };
  const handleSubmit = () => {
    navigate(`/EditCourierDetails/${id}`, {
      state: { ORDERPK: order_pk, purchase_id: order_pk, labelStatus: 1 },
    });

    // const err_bnh = validateFields(initialfields);
    // if (Object.keys(err_bnh).length === 0) {
    //   try {
    //     if (id) {
    //       // Combine all user entries
    //       let user = [
    //         ...initialfields.emailIds.map((emailId, index) => ({
    //           id: emailId,
    //           user_id: initialfields.userIds[index],
    //           is_valid: 1,
    //         })),
    //         ...removedValues.map((removedId, index) => ({
    //           id: removedId,
    //           user_id: initialfields.userIds[index],
    //           is_valid: 0,
    //         })),
    //         ...initialfields.newEmails.map((newEmail) => ({
    //           id: newEmail.id || "", // Use empty string for new emails
    //           user_id: newEmail.user_id,
    //           is_valid: 1,
    //         })),
    //       ];

    //       // Deduplicate entries by user_id
    //       const uniqueUsers = user.reduce((acc, current) => {
    //         const existingIndex = acc.findIndex(
    //           (item) => item.user_id === current.user_id
    //         );
    //         if (existingIndex > -1) {
    //           acc[existingIndex] = current; // Replace with the latest entry
    //         } else {
    //           acc.push(current);
    //         }
    //         return acc;
    //       }, []);

    //       const updateCoupon = {
    //         id: id,
    //         coupon_title: initialfields.Title,
    //         amount: initialfields.CouponAmount,
    //         end_date: initialfields.TDate,
    //         created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
    //         created_by: userid,
    //         users: uniqueUsers,
    //       };

    //       AxiosInstance.post(`api/all/coupon/add`, updateCoupon)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             toast.success(res.data.message);
    //             navigate("/ListCouponCode");
    //           } else {
    //             toast.error(res.data.message);
    //           }
    //         })
    //         .catch((error) => {
    //           console.error(error);
    //         });
    //     } else {
    //       const users = initialfields.emailIds.map((emailId, index) => ({
    //         id: emailId,
    //         user_id: initialfields.userIds[index],
    //         is_valid: 1,
    //       }));

    //       const updateCoupon = {
    //         id: "", // If edit coupon , Id value is must.
    //         coupon_title: initialfields.Title,
    //         amount: initialfields.CouponAmount,
    //         end_date: initialfields.TDate,
    //         created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
    //         created_by: userid,
    //         users: users,
    //       };
    //       console.log(updateCoupon, "updateCouponeee");

    //       AxiosInstance.post(`api/all/coupon/add`, updateCoupon)
    //         .then((res) => {
    //           // console.log(res);
    //           if (res.status === 200) {
    //             toast.success(res.data.message);
    //             navigate("/ViewPurchase");
    //           } else {
    //             toast.error(res.data.message);
    //           }
    //         })
    //         .catch((error) => {
    //           return error;
    //         });
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // } else {
    //   setError(err_bnh);
    // }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  let filtervisible_to_user = [];
  let filterPublisher = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterAuthor = [];
  function updateStateData() {
    filterAuthor = author_name;
    filterPublisher = publisher_name;
    filtervisible_to_user = visible_to_user;
    filtervisible_to_user = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
  }
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleClear = (name) => {
    if (name === "author") {
      setAuthor_name([]);
      filterAuthor = [];
    }
  };
  const handleClick = (setN, bookIds, ids) => {
    if (setN == 1) {
      navigate(`/studyMaterials/Books/ViewBookSet/${bookIds}/${ids}`);
    } else {
      navigate(`/viewIndividualBook/${ids}`);
    }
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "View Courier Details" : "Add New Courier Details"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ViewPurchase"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                Back to View Sales
                {/* {id ? "Back to View Purchase" : "Back to View Purchase"} */}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Edit Courier Details
              </Link>
            </li>
          </ul>
        </div>
        {/*  Select Books*/}
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Selected Books</legend>
            <div className="row mb-3">
              {updateChipData?.length > 0 ? (
                <div className="row mt-3">
                  <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {updateChipData.map((data, index) => {
                        let icon;
                        return (
                          <ListItem key={index}>
                            <Chip
                              icon={icon}
                              label={
                                <>
                                  <span className={StyleInfo.BoldTyText}>
                                    {data.name}
                                  </span>
                                </>
                              }
                              onDelete={handleDelete(data, index)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div className="row mx-0 mt-4">
                <div className="col-md-12 table-responsive tableMinHeight px-0 ">
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th" className={StyleInfo.tableThPadding}></th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "serialNumber")}
                            className="textHead_th"
                          >
                            S.No.
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "serialNumber")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className="textHead_th"
                          >
                            Book Name
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "author")}
                            className="textHead_th"
                          >
                            Author
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "author")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "publisher")}
                            className="textHead_th"
                          >
                            Publisher
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "publisher")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className="textHead_th"
                          >
                            Bookset Name
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "book_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "no_of_books")}
                            className="textHead_th"
                          >
                            Quantity
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "no_of_books")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>

                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "category_name")}
                            className="textHead_th"
                          >
                            Category
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "category_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className="textHead_th"
                          >
                            Course
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className="textHead_th"
                          >
                            Subject
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "medium")}
                            className="textHead_th"
                          >
                            Medium
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "medium")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            onClick={(e) => handleSort(e, "individualBookset")}
                            className="textHead_th"
                          >
                            Individual / Bookset
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "individualBookset")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>

                        {/* Delivery Status */}
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span
                            className="textHead_th"
                            onClick={(e) => handleSort(e, "delivery_status")}
                          >
                            Delivery Status
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "delivery_status")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>

                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Action</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData?.length === 0 ? (
                        <tr>
                          <td colspan="15" style={{ textAlign: "center" }}>
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        // Table Body
                        currentData?.map((book) => (
                          <tr key={book.id}>
                            <td>
                              <input
                                className={`${StyleInfo.checkBox_input} ${
                                  book.is_selected == 0 && "disabled_btn"
                                }`}
                                type="checkbox"
                                name="bookset_order"
                                disabled={book.is_selected == 0 ? true : false}
                                id={`bookset_order_${book.id}`}
                                value={book.id}
                                checked={book.is_selected == 1 ? true : false}
                              />
                            </td>
                            <td id="td">{book.serialNumber}</td>
                            <td id="td">
                              <span
                                title={book.book_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.book_name || "_"}
                              </span>
                            </td>
                            <td id="td">
                              {" "}
                              <span
                                title={book.author}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.author ? book.author : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={book.publisher}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.publisher ? book.publisher : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={book.set_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {book.set_name || "_"}
                              </span>
                            </td>
                            <td id="td">
                              {book.quantity ? book.quantity : "_"}
                            </td>

                            <td id="td">
                              {book.category_name ? book.category_name : "_"}
                            </td>
                            <td id="td">
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </td>
                            <td id="td">
                              {book.subject_name ? book.subject_name : "_"}
                            </td>
                            <td id="td">{book.medium ? book.medium : "_"}</td>
                            {/* Individal bookset */}
                            <td id="td">
                              {book.is_set == 1 ? "Bookset" : "Individual"}
                            </td>
                            <td id="td">
                              {book.delivery_status == 0 && (
                                <span
                                  className={`${StyleInfo.deliveryStatus} ${StyleInfo.deliveryStatusPink}`}
                                >
                                  Pickup Pending
                                </span>
                              )}
                              {book.delivery_status == 1 && (
                                <span
                                  className={`${StyleInfo.deliveryStatus} ${StyleInfo.deliveryStatusYellow}`}
                                >
                                  Shipping in Progress
                                </span>
                              )}
                              {book.delivery_status == 2 && (
                                <span
                                  className={`${StyleInfo.deliveryStatus} ${StyleInfo.deliveryStatusGreen}`}
                                >
                                  Delivered
                                </span>
                              )}
                            </td>
                            <td id="td">
                              <img
                                // onClick={() => handleNavigate(book.is_set )}
                                src={ViewIcon}
                                className={StyleInfo.cursor_pointer}
                                alt="view icon"
                                onClick={() =>
                                  handleClick(
                                    book.is_set,
                                    book.book_ids,
                                    book.book_id
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPage}
                  handlePageCount={handlePageCount}
                  startPage={
                    updateListData && updateListData?.length > 0
                      ? currentPage * rowsPerPage + 1 - rowsPerPage
                      : 0
                  }
                  endPage={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length < currentPage * rowsPerPage
                        ? updateListData?.length
                        : currentPage * rowsPerPage
                      : 0
                  }
                  totalRecords={
                    updateListData && updateListData?.length > 0
                      ? updateListData?.length
                      : 0
                  }
                  handlePrev={(e) => handlePrev(currentPage - 1)}
                  currentPrevPage={currentPage === 1}
                  prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                  handleNext={() => handleNext(currentPage + 1)}
                  currentNextPage={currentPage === totalPages|| totalPages == 0}
                />
              </div>
            </div>
          </fieldset>
        </div>
        {/* Courier Details */}

        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Courier Details</legend>

            <>
              <div className="row mt-3 mx-0">
                <div
                  className={`col-md-12 ${StyleInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
                >
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">AWB Number</span>
                        </th>

                        {/* <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Tracking ID</span>
                        </th> */}
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Courier Date</span>

                          <span
                            //  onClick={(e) => handleSort(e, "courierDate")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Book Names</span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Delivery Status</span>
                          <span
                            //  onClick={(e) => handleSort(e, "deliveryStatus")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <span className="textHead_th">Action</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td id="td">{courierDetails?.courier_id}</td>
                        {/* <td id="td">{courierDetails?.tracking_id}</td> */}
                        <td id="td">{courierDetails?.created_dt}</td>
                        <td id="td">
                          <span title="" className={StyleInfo.ellipsisText}>
                            {courierDetails?.book_titles}
                          </span>
                        </td>
                        <td id={`${StyleInfo.td}`}>
                          {courierDetails?.delivery_status == 0 && (
                            <span class="filterChipText bg-pink">
                              Pickup Pending
                            </span>
                          )}
                          {courierDetails?.delivery_status == 1 && (
                            <span class="filterChipText bg-orange">
                              Shipping in Progress
                            </span>
                          )}
                          {courierDetails?.delivery_status == 2 && (
                            <span class="filterChipText bg-green">
                              Delivered
                            </span>
                          )}
                        </td>
                        <td id="td">
                          <div>
                            <span>
                              {/* <img src={mapIcon} alt="MapLocationIcon" /> */}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-2">
                <Pagination
                  rowsPerPage={1}
                  // handlePageCount={handlePageCount}
                  startPage={1}
                  endPage={2}
                  totalRecords={2}
                  // handlePrev={(e) => handlePrev(currentPage - 1)}
                  currentPrevPage={1}
                  prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                  // handleNext={() => handleNext(currentPage + 1)}
                  currentNextPage={2}
                />
              </div>
            </>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
